module.exports = __webpack_public_path__ + "static/img/screenshot-approve-bidder.e193ae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshot-approve-bidder.png
// module id = ya2c
// module chunks = 1